import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  touchableOpacity: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginTop: 10,
    color: 'black',
  },
  icon: {
    color: 'black',
    marginRight: 5,
  },

  text: {
    fontSize: 12,
    color: 'black',
  },
});

export {styles};
